import React from 'react';
import PropTypes from 'prop-types';
import AddCircleIcon from '@atlaskit/icon/glyph/add-circle';
import AddIcon from '@atlaskit/icon/glyph/add';
import Button, { ButtonGroup } from '@atlaskit/button';
import FieldText from '@atlaskit/field-text';
import DropdownMenu, { DropdownItemGroup, DropdownItem } from '@atlaskit/dropdown-menu';
import uuid from 'uuid/v4';
import CrossCircleIcon from '@atlaskit/icon/glyph/cross-circle';

import Styled from './styled';
import Condition from './condition';
import ConditionToggle from './condition-toggle';

class Group extends React.Component {
  constructor(props) {
    super(props);
    this.initial = 0;
    this.console = this.props.console;
    this.data = {
      uuid: this.props.uuid,
      title: this.props.title,
      condition: this.props.condition,
      rules: this.props.rules,
    };
    this.state = {
      update: new Date().getTime(),
    };

    this.onAddCondition = this.onAddCondition.bind(this);
    this.onAddGroup = this.onAddGroup.bind(this);
    this.onGroupByType = this.onGroupByType.bind(this);
    this.onOperatorToggle = this.onOperatorToggle.bind(this);
    this.onRemoveRule = this.onRemoveRule.bind(this);
    this.onRemoveRuleByType = this.onRemoveRuleByType.bind(this);
    this.onTitleFieldText = this.onTitleFieldText.bind(this);
    this.ruleSynchronize = this.ruleSynchronize.bind(this);
  }

  componentWillMount() {
    this.console.log('© Group - Prepared');
  }

  componentDidUpdate() {
    this.console.log('© Group - Rendered');
  }

  onAddGroup() {
    this.console.log('Added a group');
    this.data.rules.push({
      uuid: uuid(),
      rules: [{
        uuid: uuid(),
      }],
    });
    this.stateUpdate();
  }

  onAddCondition() {
    this.console.log('Added a condition');
    this.data.rules.push({
      uuid: uuid(),
    });
    this.stateUpdate();
  }

  onGroupByType() {
    this.console.log('Grouped by types of rules');
    const group = this.getRuleCondition();
    const condition = this.getRuleGroup();

    if (group.length && condition.length) {
      this.data.rules = [...group, ...condition];
      this.synchronize();
      this.stateUpdate();
    }
  }

  onRemoveRule(key) {
    this.console.log('A rule was deleted');
    this.data.rules = this.data.rules.filter(rule => rule.uuid !== key);
    this.synchronize();
    this.stateUpdate();
  }

  onRemoveRuleByType(type) {
    this.console.log(`Remove ${type}`);
    const rules = type === 'Groups' ? this.getRuleCondition() : this.getRuleGroup();

    if (rules.length < this.data.rules.length) {
      this.data.rules = rules;
      this.synchronize();
      this.stateUpdate();
    }
  }

  onOperatorToggle() {
    this.console.log('© Group - Condition changed');
    this.data.condition = this.data.condition === 'and' ? 'or' : 'and';
    this.synchronize();
  }

  onTitleFieldText(event) {
    this.console.log('© Group - Title changed');
    this.data.title = event.target.value;
    this.synchronize();
  }

  getRuleGroup() {
    return this.data.rules.filter(rule => rule.rules);
  }

  getRuleCondition() {
    return this.data.rules.filter(rule => !rule.rules);
  }

  stateUpdate() {
    this.setState({ update: new Date().getTime() });
  }

  overrideRuleByKey(key, data) {
    const rules = this.data.rules.map((rule) => {
      if (rule.uuid === key) return { ...rule, ...data };
      return rule;
    });

    this.data.rules = rules;
  }

  ruleSynchronize(key, data) {
    this.initial = this.initial + 1;
    this.overrideRuleByKey(key, data);

    if (this.initial >= this.data.rules.length) {
      this.synchronize();
    }
  }

  synchronize() {
    this.props.synchronize(this.props.uuid, this.data);
  }

  renderAddGroupButton() {
    const props = {
      iconBefore: <AddCircleIcon size="small" label="Add Group" />,
      onClick: this.onAddGroup,
    };

    return this.props.isMobile
      ? <Button {...props}>Group</Button>
      : <Button {...props}>Add Group</Button>;
  }

  renderAddConditionButton() {
    const props = {
      iconBefore: <AddIcon size="small" label="Add Condition" />,
      onClick: this.onAddCondition,
    };

    return this.props.isMobile
      ? <Button {...props}>Condition</Button>
      : <Button {...props}>Add Condition</Button>;
  }

  renderRemoveThisButton() {
    if (this.props.main) return false;

    const props = {
      onClick: () => this.props.remove(this.props.uuid),
    };

    return <DropdownItem {...props}>Your Self</DropdownItem>;
  }

  renderRemoveGroupsButton() {
    const props = {
      onClick: () => this.onRemoveRuleByType('Groups'),
    };

    return <DropdownItem {...props}>Groups</DropdownItem>;
  }

  renderRemoveConditionsButton() {
    const props = {
      onClick: () => this.onRemoveRuleByType('Conditions'),
    };

    return <DropdownItem {...props}>Conditions</DropdownItem>;
  }

  renderTitleFieldText() {
    const props = {
      compact: true,
      disabled: true,
      onChange: this.onTitleFieldText,
      shouldFitContainer: true,
      placeholder: this.data.title,
      // value: this.data.title,
    };

    return <FieldText {...props} />;
  }

  renderGroupByTypeButton() {
    const props = {
      onClick: this.onGroupByType,
    };

    return <DropdownItem {...props}>Group by type</DropdownItem>;
  }

  renderOptionsDropDown() {
    return (
      <DropdownMenu
        trigger="Options"
        triggerType="button"
        position="bottom right"
        shouldAllowMultilineItems
      >
        <DropdownItemGroup title="Remove">
          {this.renderRemoveThisButton()}
          {this.renderRemoveGroupsButton()}
          {this.renderRemoveConditionsButton()}
        </DropdownItemGroup>
        <DropdownItemGroup title="Other">
          {this.renderGroupByTypeButton()}
        </DropdownItemGroup>
      </DropdownMenu>
    );
  }

  renderButtonRemove() {
    if (this.props.main) return false;

    const props = {
      onClick: () => this.props.remove(this.props.uuid),
      iconBefore: <CrossCircleIcon size="small" label="Remove Group" />,
    };

    return this.props.isMobile
      ? <Button {...props} />
      : <Button {...props}>Remove</Button>;
  }

  render() {
    const { isMobile } = this.props;

    return (
      <Styled.Group data-update={this.state.update}>
        <Styled.Flex>
          {!this.props.main ? (
            <Styled.FlexItem nowrap>
              <ConditionToggle
                disabled={this.props.index}
                isMobile={isMobile}
                onChange={this.onOperatorToggle}
                value={this.data.condition}
              />
            </Styled.FlexItem>
          ) : null}
          <Styled.FlexItem>
            <Styled.FieldText>
              {this.renderTitleFieldText()}
            </Styled.FieldText>
          </Styled.FlexItem>
          <Styled.FlexItem nowrap>
            <ButtonGroup>
              {this.renderAddGroupButton()}
              {this.renderAddConditionButton()}
              {isMobile && this.renderButtonRemove()}
              {!isMobile && this.renderOptionsDropDown()}
            </ButtonGroup>
          </Styled.FlexItem>
        </Styled.Flex>
        <Styled.GroupContent>
          {this.data.rules.map((elem, index) => {
            const props = {
              ...elem,
              index,
              console: this.console,
              fields: this.props.fields,
              isMobile: this.props.isMobile,
              key: elem.uuid,
              remove: this.onRemoveRule,
              synchronize: this.ruleSynchronize,
            };
            return elem.rules ? <Group {...props} /> : <Condition {...props} />;
          })}
        </Styled.GroupContent>
      </Styled.Group>
    );
  }
}

Group.propTypes = {
  condition: PropTypes.string,
  isMobile: PropTypes.bool.isRequired,
  console: PropTypes.shape().isRequired,
  fields: PropTypes.arrayOf(PropTypes.object).isRequired,
  index: PropTypes.number.isRequired,
  main: PropTypes.bool,
  remove: PropTypes.func,
  rules: PropTypes.arrayOf(PropTypes.object),
  synchronize: PropTypes.func.isRequired,
  title: PropTypes.string,
  uuid: PropTypes.string,
};

Group.defaultProps = {
  condition: 'and',
  main: false,
  remove: () => true,
  rules: [],
  title: 'Grup',
  uuid: uuid(),
};

export default Group;
